<template>
  <div class="Echarts">
    <div id="chart" style="margin-top: 40px;width: 100%;height:420px;"></div>
  </div>
</template>

<script>
import { formatNumberRgx2 } from "@/utils/utils";
export default {
  name: 'Echarts',
  props: {
    leftSeriesData: {
      type: Array,
      required: true
    },
    rightSeriesData: {
      type: Array,
      required: true
    },
    dateData: {
      type: Array,
      required: true
    },
    legendData: {
      type: Array,
      required: true
    },
    chartTitle: {
      type: String,
      required: false
    },
    pageType: {
      type: String,
      required: true
    }
  },
  computed: {
    options() {
      const that = this
      var colors = ['#3FA7DC', '#FE9400', '#EE6666']
      var option = {
        color: colors,
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            const axisValueLabel = params[0].axisValueLabel
            let src = axisValueLabel + '<br>';
            for (const x in params) {
              let value = null
              if (params[x].seriesName && params[x].seriesName.includes('率')) {
                value = `${formatNumberRgx2(params[x].value * 100)} %`
              } else {
                value = params[x].value
              }
              src += params[x].marker + params[x].seriesName + ": " + value + '<br>';
            }
            return src
          },
        },
        grid: {
          y2: 77
        },
        legend: {
          data: this.legendData
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              rotate: that.pageType === 'timeOrgTerm' ? 0 : 30,
              formatter: function(params) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = that.pageType === 'timeOrgTerm' ? 11 : 8;
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = "";
                    var start = p * provideNumber;
                    var end = start + provideNumber;
                    if (p === rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = params;
                }
                return newParamsName
              }
            },
            data: this.dateData
          }
        ],
        yAxis: [
          {
            type: 'value',
            // name: this.legendData[0],
            min: 0,
            max: that.legendData[0] && that.legendData[0].includes('率') ? this.leftSeriesData && this.leftSeriesData.length ? 1 : 0 : this.hanleNum(Math.max(...this.leftSeriesData) || 10),
            splitNumber: 5,
            interval: that.legendData[0] && that.legendData[0].includes('率') ? this.leftSeriesData && this.leftSeriesData.length ? 0.2 : 0 : this.hanleNum(Math.max(...this.leftSeriesData) || 10) / 5,
            position: 'left',
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: colors[0]
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: function (value, index) {
                return that.legendData[0] && that.legendData[0].includes('率') ? `${formatNumberRgx2(value * 100)} %` : Math.round(value);
              }
            }
          },
          {
            type: 'value',
            // name: this.legendData[1],
            min: 0,
            max: that.legendData[1] && that.legendData[1].includes('率') ? this.rightSeriesData && this.rightSeriesData.length ? 1 : 0 : this.hanleNum(Math.max(...this.rightSeriesData) || 10),
            splitNumber: 5,
            interval: that.legendData[1] && that.legendData[1].includes('率') ? this.rightSeriesData && this.rightSeriesData.length ? 0.2 : 0 : this.hanleNum(Math.max(...this.rightSeriesData) || 10) / 5,
            position: 'right',
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: colors[1]
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: function (value, index) {
                return that.legendData[1] && that.legendData[1].includes('率') ? `${formatNumberRgx2(value * 100)} %` : Math.round(value);
              }
            }
          }
        ],
        series: [
          {
            name: this.legendData[0],
            type: 'line',
            yAxisIndex: 0,
            data: this.leftSeriesData
          },
          {
            name: this.legendData[1],
            type: 'line',
            yAxisIndex: 1,
            data: this.rightSeriesData
          }
        ]
      };
      return option
    }
  },
  methods: {
    hanleNum(n) {
      return (Math.floor(n / 5) + 1) * 5
    },
    myEcharts() {
      var myChart = this.$echarts.init(document.getElementById('chart'));
      this.myChart = myChart;
      myChart.setOption(this.options);
      window.addEventListener('resize', function() {
        myChart.resize();
      });
    }
  },
  mounted() {
    this.myEcharts();
  },
  watch: {
    options: {
      handler(newVal, oldVal) {
        if (this.myChart) {
          if (newVal) {
            this.myChart.clear();
            this.myChart.setOption(newVal)
          } else {
            this.myChart.setOption(oldVal)
          }
        } else {
          this.myEcharts()
        }
      }
    },
    deep: true
  }
}
</script>

<style lang="less" scoped>
.Echarts{
  position: relative;
}
</style>
